import { BaseModel } from './base.model'

// Model name is 'Photo' because 'Image' name is taken
export class Photo extends BaseModel<Photo> {
  static DEFAULT_ATTRIBUTES = {
    _destroy: false
  }

  _destroy: boolean
  id: number
  url: string
  thumbUrl: string
  type: string

  filename(): string {
    if(!this.url) { return null }
    return this.url.split('/').pop().split('?')[0]
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/photo.model.ts